import classNames from "classnames";
import { setTrackingId } from "client/Misc/utils";
import styles from "./AiAssistantAvatar.module.less";
import { ReactElement } from "react";

export type AiAssistantAvatarSize =
	| "default"
	| "small"
	| "x-small";

export type AiAssistantAvatarProps = {
	imageUrl?: string | null;
	size?: AiAssistantAvatarSize;
	trackingId: string;
};

export const AiAssistantAvatar = (props: AiAssistantAvatarProps): ReactElement => {
	const {
		size = "default",
		imageUrl,
		trackingId
	} = props;

	return (
		<div
			{...setTrackingId(trackingId)}
			className={classNames(
				styles.root,
				sizeToClassNameMap[size]
			)}
			style={
				imageUrl
					? {
						backgroundImage: `url(${imageUrl})`
					}
					: undefined
			}
		/>
	);
};
AiAssistantAvatar.displayName = "AiAssistantAvatar";

const sizeToClassNameMap: Record<AiAssistantAvatarSize, string | null> = {
	"default": null,
	"small": styles.root_small,
	"x-small": styles.root_xSmall
};
